import React, { Component } from 'react';
import { ReactComponent as AppleLogo } from '../../assets/images/Apple-Logo.svg';
import styles from './landing.module.css';
import {
    Container, Row, Col, Form, FormGroup, Label, Input
} from 'reactstrap';
import DatePicker from 'react-date-picker';
import classNames from 'classnames';
import SimpleReactValidator from 'simple-react-validator';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router';
import Calendar from 'react-calendar';
import Cleave from 'cleave.js/react';
import { ReactComponent as CalendarIcon } from '../../assets/images/calendar.svg';
import moment from 'moment';
import { withCookies, Cookies } from "react-cookie";

let dateInput = styles.dateInput;
let formControl = "form-control";
let daysBeforeMaxSelectableDate = -6;

class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            continuing: false,
            tempDate: '',
            showCalendar: false,
            showResult: false,
            contractNumber: '',
            serialNumber: '',
            cancellationDate: '',
            responseData: null,
            found: true,
            cookies: this.props.cookies.get("XSRFTOKEN") || ""
        }
        this.baseState = this.state
        this.handleCalendarDate = this.handleCalendarDate.bind(this);
        this.handleCleaveDate = this.handleCleaveDate.bind(this);
        this.openCalendar = this.openCalendar.bind(this);
        this.validator = new SimpleReactValidator({
            element: message => <div className="validationSummary">{message}</div>,
            validators: {

                valid_date: {
                    message: 'The :attribute is invalid.',
                    rule: (val, params, validator) => {
                        let date = moment(val).format('MM/DD/YYYY');
                        console.log(date, val);
                        return validator.helpers.testRegex(val, /^((((0[13578])|([13578])|(1[02]))[\/](([1-9])|([0-2][0-9])|(3[01])))|(((0[469])|([469])|(11))[\/](([1-9])|([0-2][0-9])|(30)))|((2|02)[\/](([1-9])|([0-2][0-9]))))[\/]\d{4}$|^\d{4}$/) && params.indexOf(date) === -1
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                },
                future_date: {
                    message: "Cancellation date must be within 7 days of the present date.",
                    rule: (val, params, validator) => {

                        const current = moment().format("MM/DD/YYYY");
                        const compareDate = moment(val).format("MM/DD/YYYY");
                        console.log(compareDate + " ---- " + current, val);

                        const diff = moment(compareDate).diff(current, 'day')
                        console.log('diff', diff)
                        console.log('premiumAmount:', this.state.responseData);
                        return diff >= daysBeforeMaxSelectableDate && diff <= 0;
                    }
                }
            }
        })
    }
    handleIncidentDate = e => {
        this.setState({
            cancellationDate: e
        });
    }

    handleCleaveDate = e => {
        let cleaveDate = e.target.value;
        let date = new Date(cleaveDate);
        let dateOutOfRange = false;
        //console.log(date, typeof date);

        var enteredDate = moment(cleaveDate, "MM/DD/YYYY", true);
        if (enteredDate.isValid) {
            var maxDate = moment().format("MM/DD/YYYY");
            var minDate = moment(maxDate).add(daysBeforeMaxSelectableDate, 'days');

            if (enteredDate.isBefore(minDate) || enteredDate.isAfter(maxDate)) {
                dateOutOfRange = true;
                this.setState({
                    tempDate: '',
                    cancellationDate: ''
                });
            }
        }

        if (!dateOutOfRange) {
            if (!isNaN(date.getTime())) {
                this.setState({
                    tempDate: cleaveDate,
                    cancellationDate: date
                });
            }
            else {
                this.setState({
                    tempDate: cleaveDate
                });
            }
        }

        if (this.validator.helpers.testRegex(cleaveDate, /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/)) {
            this.openCalendar(false);
        }
    }

    handleCalendarDate = e => {

        this.setState({
            tempDate: moment(e).format("MM/DD/YYYY"),
            cancellationDate: moment(e).format("MM/DD/YYYY"),
        });

        this.openCalendar(false);
    }

    openCalendar = (e) => {
        //e.preventDefault();
        try {
            this.setState({
                showCalendar: e
            })
        }
        catch {
            this.setState({
                showCalendar: false
            })
        }

    }

    checkIfError = field => {
        var messages = this.validator.getErrorMessages();
        for (var i = 0; i < messages.length; i++) {
            console.log(messages[i]);
        }

    }

    handleTextInput = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        }); //console.log(this.validator.getErrorMessages());
    }
    handleReset = () => {
        this.setState(this.baseState)
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ continuing: true, found: true, showResult: false });
        const value = {
            contractNumber: this.state.contractNumber,
            serialNumber: this.state.serialNumber,
            cancellationDate: moment(this.state.cancellationDate).toISOString(true)
        }

        if (this.validator.allValid()) {
            this.setState({ continuing: true })
            const data = {
                method: 'POST',
                body: JSON.stringify(value),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XSRFTOKEN': this.state.cookies
                }
            }

            const response = await fetch(`/api/refund/CalculateRefund/apple`, data);
            if (!response.ok) {
                this.setState({ continuing: false, found: false })
                return;
            }

            try {
                const responseData = await response.json();
                this.setState({ continuing: false, showResult: true })
                this.setState({ responseData })
            } catch (err) {
                this.setState({ continuing: false, found: false })

            }

        } else {
            this.validator.showMessages();
            this.setState({ continuing: false });
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }


    }
    render() {
        return (
            <>
                <Container className="contentWrapper">
                    <Form className={styles.refCalcForm}>
                        <Row>
                            <Col>

                                <h1>AIG Refund Calculator</h1>
                            </Col>
                        </Row>
                        <>
                            <form class="w-100" ref={form => this.form = form}>
                                <Row className={styles.search}>
                                    <Col md="6" lg="4" className="mx-auto">
                                        <FormGroup>
                                            <Label for="searchCaseNum" className="form-label">AppleCare+ Contract Number</Label>
                                            <span aria-hidden="true" className="required-indicator">*</span>
                                            <Input type="text" className="form-control" id="searchCaseNum"
                                                name="contractNumber" value={this.state.contractNumber} onChange={this.handleTextInput} />
                                            {this.validator.message("contractNumber", this.state.contractNumber, "required")}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="searchZip" className="form-label">Serial Number</Label>
                                            <span aria-hidden="true" className="required-indicator">*</span>
                                            <Input type="text" className="form-control" id="searchZip"
                                                name="serialNumber" value={this.state.serialNumber} onChange={this.handleTextInput} />
                                            {this.validator.message("serialNumber", this.state.serialNumber, "required")}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="searchZip" className="form-label">Cancellation Date</Label>
                                            <span aria-hidden="true" className="required-indicator">*</span>
                                            <div className="input-group">
                                                <Cleave onFocus={() => this.openCalendar(true)} autocomplete="off" className="form-control" name="cancellationDate" value={this.state.tempDate} onChange={this.handleCleaveDate} options={{
                                                    date: true,
                                                    delimiter: '/',
                                                    datePattern: ['m', 'd', 'Y']
                                                }} />
                                                <CalendarIcon className={styles.datePicker} name="calendarIcon" onClick={() => this.openCalendar(true)} />
                                                {this.state.showCalendar &&
                                                    <Calendar name="cancellationDate" value={new Date(this.state.cancellationDate || moment().format())} onChange={this.handleCalendarDate} minDate={new Date(moment().add(daysBeforeMaxSelectableDate, 'days'))} maxDate={new Date(moment())} />
                                                }
                                            </div>
                                            {this.validator.message("cancellationDate", this.state.tempDate, "required|valid_date|future_date")}
                                        </FormGroup>
                                        {!this.state.found &&
                                            <div className="validationSummary" role="alert">Sorry, we couldn’t find a match in our system. Please review and try again.</div>
                                        }
                                    </Col>
                                </Row>
                            </form>
                            <div className={styles.refundCalBtnWrapper}>
                                <button className="btnLink font-weight-bold" onClick={this.handleReset} type="reset"> Clear All</button>
                                <button className="btn btn-primary" onClick={this.handleSubmit}>
                                    <Spinner color="light" animation={this.state.continuing ? "border" : ""} />
                                    {this.state.continuing ? "" : "Calculate Refund"}
                                </button>
                            </div>

                            {(this.state.responseData && this.state.showResult) && <div className={classNames("row", styles.calculatedAmount)}>
                                <div>
                                    <p>Confirmation Number:</p>
                                    <p>{this.state.responseData && this.state.responseData.confirmationNumber}</p>
                                </div>
                                <span className={classNames(styles.divider, "show-md-up")}></span>
                                <div>
                                    <p>Refund Amount:</p>
                                    <p>$ {this.state.responseData && this.state.responseData.refundAmount && this.state.responseData.refundAmount.toFixed(2)}</p>
                                </div>
                            </div>
                            }
                        </>
                    </Form>
                </Container>
            </>
        );
    }
}
export default withCookies(Landing);


